import React from "react"
import PropTypes from "prop-types"
import { withRadium, DetectCompact } from "higher-order-components"
import { AnimatedPlusMinus } from "containers"
import { GlobalNavLink } from "components"

/** Navigation Dropdown Component. */
/**
 * @param {String} label - Navigation Label
 * @param {Array|Overlay} components - Nested Components.
 * @returns {ReactElement} React Component
 */
const GlobalNavDropdown = ({
  toggleActive,
  label,
  subNav,
  active,
  close,
  compact,
  height,
  children = [],
  ...extra
}) => {
  return (
    <div style={[styles.base, subNav ? subNav.base : topNav.base]}>
      <GlobalNavLink type="span" onClick={toggleActive} label={label} subNav={subNav} active={active} chevron={compact} {...extra}>
        {subNav && (
          <div style={subNav.iconPos}>
            <AnimatedPlusMinus open={active} />
          </div>
        )}
      </GlobalNavLink>
      {React.Children.map(children, (component, index) =>
        React.cloneElement(component, {
          key: index,
          active,
          subNav,
          close,
          height,
          nav: true
        }))}
    </div>
  )
}

GlobalNavDropdown.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string.isRequired,
  toggleActive: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  subNav: PropTypes.bool,
  compact: PropTypes.bool,
  height: PropTypes.number,
  close: PropTypes.func
}

export default withRadium(DetectCompact({ threshold: 900 }))(GlobalNavDropdown)

const styles = {
  base: {
    textTransform: "uppercase",
    cursor: "pointer",
    transition: ".25s",
    position: "relative",
    "@media (min-width: 900px)": {
      position: "static"
    }
  }
}

const topNav = {
  base: {
    display: "inline-block"
  }
}



// WEBPACK FOOTER //
// ./src/components/global-nav-dropdown/index.jsx